import { Injectable } from '@angular/core';
import { Type } from 'src/app/pages/models/type/type.model';

@Injectable({
  providedIn: 'root'
})
export class TypeItemServiceService {

  getItems(): Type[]{
    return [
      {
        id: 1,
        head: "All",
        image: "assets/all.png",
        active: true
      },
      {
        id: 2,
        head: 'Cuisine',
        image: "assets/scoot.png",
        active: false
      },
      {
        id: 3,
        head: 'Essentials',
        image: "assets/house.png",
        active: false
      },
      {
        id: 4,
        head: 'Beverages',
        image: "assets/scoot.png",
        active: false
      },
      {
        id: 5,
        head: 'Others',
        image: "assets/others.png",
        active: false
      }
    ]
  }

  getTypeItem(id: number): Type{
    return this.getItems().find((type) => type.id === id);
  }
}
